import React, { useEffect } from "react"
import { useRenderStyling } from "lib/hooks/useRenderStyling"
import { parseContent, parseContentGroup } from "./utils"
import { formatSequentialString } from "lib/utils/policies"
import SectionHeaderRender from "lib/units/element/SectionHeader/SectionHeaderRender"
import { PolicyBlock } from "."

export default function PoliciesRender({ renderPkg }:{ renderPkg?:any }){

  const settings = renderPkg.dispute.elements.find((setting:any) => setting.refstr === "policies").settings || {}

  const firstPStyle = useRenderStyling("block mb-0 leading-tight", "styleObj")
  const outerStyling = useRenderStyling("mm-section w-full flex flex-col pl-0 mb-4", "styleObj")
  const innerStyling = useRenderStyling("w-full mt-4 pl-4 pr-6", "styleObj")
  const wrapperStyling = useRenderStyling("mt-3 mb-1", "styleObj")
  const contentStyling = useRenderStyling("flex flex-col leading-tight", "styleObj")

  const parseProps = { clientDataObj: renderPkg.clientdata, apiData: renderPkg.apidata} 

  let policies:any[] = [] 
  const returnPolicy = parseContent({ content: "[[merchant.ReturnPolicy]]", ...parseProps})?.result
  const returnPolicyUrl = parseContent({ content: "[[merchant.ReturnPolicyUrl]]", ...parseProps})?.result

  const refundPolicy = parseContent({ content: "[[merchant.RefundPolicyText]]", ...parseProps})?.result
  const refundPolicyUrl = parseContent({ content: "[[merchant.RefundPolicyUrl]]", ...parseProps})?.result

  const termsText = parseContent({ content: "[[merchant.TermsText]]", ...parseProps})?.result
  const termsUrl = parseContent({ content: "[[merchant.TermsUrl]]", ...parseProps})?.result 
    
  const cancellationPolicyText = parseContent({ content: "[[merchant.CancellationPolicyText]]", ...parseProps})?.result
  const cancellationPolicyUrl = parseContent({ content: "[[merchant.CancellationPolicyUrl]]", ...parseProps})?.result 
      
  if( returnPolicy && returnPolicy.length ) policies.push("return")
  if( refundPolicy && refundPolicy.length ) policies.push("refund")
  if( termsText && termsText.length ) policies.push("terms")
  if( cancellationPolicyText && cancellationPolicyText.length ) policies.push("cancel")

  return (
    <div id="mm-policies" {...outerStyling}>

      <SectionHeaderRender title="Policies" />

      <div {...innerStyling}>
        <span {...firstPStyle}>We have clear {formatSequentialString(policies)} policies as seen below:</span> 
        <div {...wrapperStyling}>
          <div {...contentStyling}>
            { policies.includes("return") && (
              <PolicyBlock policy={{ type: "return", text: returnPolicy, url: returnPolicyUrl }} />
            )}

            { policies.includes("refund") && (
              <PolicyBlock policy={{ type: "refund", text: refundPolicy, url: refundPolicyUrl }} />
            )}

            { policies.includes("terms") && (
              <PolicyBlock policy={{ type: "terms", text: termsText, url: termsUrl }} />
            )}

            { policies.includes("cancel") && (
              <PolicyBlock policy={{ type: "cancel", text: cancellationPolicyText, url: cancellationPolicyUrl }} />
            )}
          </div>
        </div>
      </div>
    </div>
  )
}